import { render, staticRenderFns } from "./CarouselControls.vue?vue&type=template&id=1e6250ce"
import script from "./CarouselControls.vue?vue&type=script&lang=js"
export * from "./CarouselControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports